import React, { useContext, useState } from "react";
import {
  List,
  Button,
  Typography,
  Tooltip,
  message,
  notification,
  Badge,
  Popconfirm,
  Skeleton,
  Select,
} from "antd";

import "../component/permission.css";
import { Dialog, DialogFooter } from "@fluentui/react/lib/Dialog";
import { TextField } from "@fluentui/react/lib/TextField";
import {
  PrimaryButton,
  DefaultButton,
} from "@fluentui/react/lib/Button";
import * as yup from "yup";
import { observer } from "mobx-react";
import { Formik, Form } from "formik";
import { Scrollbars } from "react-custom-scrollbars";
import { Spinner, SpinnerSize } from "@fluentui/react";
import PermissionStore from "../store/permissionStore";
import { MessageBar, MessageBarType } from "@fluentui/react";

import { DeleteOutlined, EditOutlined, PlusOutlined } from "@ant-design/icons";
const { Title } = Typography;
const _ = require("underscore");
const { Option } = Select;
export const Role = observer((props) => {
  const permissionStore = useContext(PermissionStore);
  const [state, setState] = useState({
    hideDialog: true,
    action: "",
    selRow: {},
  });

  const _closeDialog = () => {
    setState({ hideDialog: true });
  };
  const handleSubmit = async (values, { setSubmitting }) => {
    try {
      const permissions = _.pluck(
        [...permissionStore.priviledges.values()],
        "name"
      );

      const isExist = _.contains(
        permissions.map((x) => x.toLowerCase()),
        values.name.toLowerCase()
      );
      console.log(isExist);
      if (state.action === "add" && isExist) {
        //check for duplicate
        notification.error({
          message: "SPARS Feedback",
          description: "invalid operation, account group already exist",
        });

        setSubmitting(false);
        return;
      }

      //check for undefined copyfrom
      if (state.action === "add" && !values.copyfrom) {
        notification.open({
          message: "Feedback Manager",
          type: "error",

          description: "select group template to copy from",
        });
        setSubmitting(false);
        return;
      }
      const formValues = { ...values };
      const newRoleId = await permissionStore.createOrUpdatePriviledge(
        formValues,
        state.action
      );

      await props.onRoleClick({
        ...formValues,
        groupId: newRoleId,
      });

      if (state.action === "add") {
        message.success("Save sucessfull");
      } else {
        message.success("Modification sucessfull");
      }
      _closeDialog();
      setSubmitting(false);
    } catch (error) {
      notification.open({
        message: "Feedback Manager",
        type: "error",

        description: `Something went wrong.${error.message}.`,
      });
      setSubmitting(false);
    }
  };
  return (
    <div
      className="ms-Grid"
      dir="ltr"
      style={{ borderRight: "1px solid #F0F2F5", marginRight: "5px" }}
    >
      <div className="ms-Grid-row">
        <div className="ms-Grid-col ms-sm12">
          {" "}
          <Scrollbars style={{ height: "100vh", overflowX: "hidden" }}>
            {permissionStore.isLoadingPrivilege ? (
              <>
                <Skeleton active />
                <Skeleton active />
                <Skeleton active />
              </>
            ) : (
              <List
                itemLayout="horizontal"
                dataSource={[...permissionStore.priviledges.values()]}
                size="small"
                style={{ width: "95%" }}
                header={
                  <div className="ms-Grid" dir="ltr">
                    <div className="ms-Grid-row">
                      <div className="ms-Grid-col ms-sm10">
                        {" "}
                        <Title
                          level={4}
                          style={{
                            display: "inline-block",
                            marginRight: "5px",
                            fontSize: "16px",
                            color: "red",
                          }}
                        >
                          Account Groups
                        </Title>
                        <Badge count={permissionStore.priviledges.size} />
                      </div>
                      <div
                        className="ms-Grid-col ms-sm2"
                        style={{
                          textAlign: "right",
                          display: "flex",
                          justifyContent: "center",
                        }}
                      >
                        <Tooltip title="Add new role">
                          <Button
                            shape="circle"
                            icon={<PlusOutlined />}
                            type="primary"
                            onClick={(ev) => {
                              setState({
                                hideDialog: false,
                                action: "add",
                                header: `Create New Account Group`,
                                selRow: {},
                              });
                            }}
                          />
                        </Tooltip>
                      </div>
                    </div>
                    <div className="ms-Grid-row" style={{ paddingTop: "10px" }}>
                      <div className="ms-Grid-col ms-sm12">
                        <MessageBar messageBarType={MessageBarType.warning}>
                          click an account group for users and permissions
                        </MessageBar>
                      </div>
                    </div>
                  </div>
                }
                renderItem={(item) => (
                  <List.Item
                    actions={
                      !item?.isSystemAdmin && [
                        <Tooltip title={`modify ${item?.name} account group`}>
                          <Button
                            type="link"
                            icon={<EditOutlined />}
                            style={{ fontSize: "18px" }}
                            onClick={() => {
                              setState({
                                action: `edit`,
                                header: `Change ${item?.name.toLowerCase()} account group attribute`,
                                hideDialog: false,
                                selRow: item,
                              });
                            }}
                          />
                        </Tooltip>,
                        <Tooltip
                          title={`Delete ${item?.name.toLowerCase()} account group`}
                        >
                          <Popconfirm
                            title={`Are you sure you want to remove ${item?.name} privilege？`}
                            okText="Yes"
                            cancelText="No"
                            onConfirm={() => {
                              try {
                                permissionStore.removePriviledge(item);
                                message.success(
                                  `${item.name} account group removal was successfull`
                                );
                              } catch (error) {
                                message.error(
                                  `something went wrong  due to : ${error.message} `
                                );
                              }
                            }}
                          >
                            <Button
                              type="link"
                              icon={<DeleteOutlined />}
                              style={{ fontSize: "18px" }}
                            />
                          </Popconfirm>
                        </Tooltip>,
                      ]
                    }
                  >
                    <List.Item.Meta
                      title={
                        <Button
                          type="link"
                          style={{
                            fontSize: "16px",
                            color: "#108ee9",
                            lineHeight: "24px",
                          }}
                          onClick={(ev) => {
                            props.onRoleClick(item);
                          }}
                        >
                          <span>{item.name}</span>
                        </Button>
                      }
                      description={item.description}
                    />
                  </List.Item>
                )}
              />
            )}
          </Scrollbars>
        </div>
      </div>
      <div className="ms-Grid-row">
        <div className="ms-Grid-col ms-sm12">
          <Dialog
            hidden={state.hideDialog}
            onDismiss={_closeDialog}
            dialogContentProps={{
              title: state.header,
              subText: "Enter name and description for the account group.",
            }}
            modalProps={{
              isBlocking: false,
              styles: { main: { maxWidth: 450 } },
              dragOptions: true,
            }}
          >
            <Formik
              initialValues={state.selRow}
              onSubmit={(values, { setSubmitting }) => {
                handleSubmit(values, { setSubmitting });
              }}
              validationSchema={yup.object().shape({
                name: yup
                  .string()

                  .required("account group name is required"),
                description: yup
                  .string()

                  .required("account group description is required"),
              })}
            >
              {({
                values,
                errors,
                touched,
                handleChange,
                handleBlur,
                handleSubmit,
                isSubmitting,
                setFieldValue,
              }) => {
                return (
                  <Form onSubmit={handleSubmit}>
                    <div className="ms-Grid" dir="ltr">
                      <div className="ms-Grid-row">
                        <div className="ms-Grid-col ms-sm12">
                          <label
                            htmlFor="account-group-name"
                            style={{ display: "block", marginBottom: "6px", fontWeight: 600 }}
                          >
                            Group Name <span style={{ color: "#a4262c" }}>*</span>
                          </label>
                          <TextField
                            id="account-group-name"
                            required
                            name="name"
                            value={values.name}
                            onBlur={handleBlur}
                            onChange={handleChange}
                            errorMessage={touched.name && errors.name}
                          />
                        </div>
                      </div>
                      <div className="ms-Grid-row">
                        <div className="ms-Grid-col ms-sm12">
                          <label
                            htmlFor="account-group-description"
                            style={{ display: "block", marginBottom: "6px", fontWeight: 600 }}
                          >
                            Group Description <span style={{ color: "#a4262c" }}>*</span>
                          </label>
                          <TextField
                            id="account-group-description"
                            multiline
                            rows={5}
                            name="description"
                            value={values.description}
                            onBlur={handleBlur}
                            onChange={handleChange}
                            errorMessage={
                              touched.description && errors.description
                            }
                          />
                        </div>
                      </div>
                      {state.action === "add" ? (
                        <div
                          className="ms-Grid-row"
                          style={{ paddingTop: "10px" }}
                        >
                          <div className="ms-Grid-col ms-sm12">
                            <label
                              htmlFor="account-group-copyfrom"
                              style={{ display: "block", marginBottom: "6px", fontWeight: 600 }}
                            >
                              Copy from group template <span style={{ color: "#a4262c" }}>*</span>
                            </label>
                            <Select
                              id="account-group-copyfrom"
                              style={{ width: "100%" }}
                              placeholder="select group template to copy from"
                              onChange={(val) => {
                                console.log(val);
                                setFieldValue("copyfrom", val);

                                //handleChange(ev);
                              }}
                            >
                              {[...permissionStore.priviledges.values()].map(
                                (x) => (
                                  <Option key={x.groupId} value={x.groupId}>
                                    {x.name}
                                  </Option>
                                )
                              )}
                            </Select>
                          </div>
                        </div>
                      ) : null}

                      <div
                        className="ms-Grid-row"
                        style={{ marginTop: "10px" }}
                      >
                        <div className="ms-Grid-col ms-sm12">
                          {isSubmitting && (
                            <Spinner
                              label="saving, please wait..."
                              ariaLive="assertive"
                              labelPosition="right"
                              size={SpinnerSize.large}
                            />
                          )}
                        </div>
                      </div>
                      <DialogFooter>
                        <PrimaryButton text="Save" type="submit" />
                        <DefaultButton onClick={_closeDialog} text="Cancel" />
                      </DialogFooter>
                    </div>
                  </Form>
                );
              }}
            </Formik>
          </Dialog>
        </div>
      </div>
    </div>
  );
});

